import { NgModule } from '@angular/core';
import { AvatarModule } from 'ngx-avatar';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { FilterPipe } from '../pipes/filter.pipe';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [FilterPipe],
  imports: [
    CommonModule,
    FormlyModule,
    MatIconModule,
    MatRadioModule,
    AvatarModule,
    MatTableModule,
    MatMenuModule,
    MatListModule,
    MatInputModule,
    MatCardModule,
    MatChipsModule,
    MatSelectModule,
    MatButtonModule,
    MatStepperModule,
    MatDividerModule,
    MatToolbarModule,
    FlexLayoutModule,
    HttpClientModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    FormlyMaterialModule,
    MatButtonToggleModule,
    FormlyMatToggleModule,
    MatProgressSpinnerModule
  ],
  exports: [
    FlexLayoutModule,
    FormlyModule,
    MatCardModule,
    MatInputModule,
    MatStepperModule,
    MatIconModule,
    AvatarModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    MatCardModule,
    MatChipsModule,
    MatTableModule,
    MatButtonModule,
    MatDividerModule,
    HttpClientModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    FormlyMaterialModule,
    MatProgressBarModule,
    FormlyMatToggleModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatExpansionModule,
    FilterPipe,
    MatProgressSpinnerModule
  ],
})
export class GtapMaterialsModule {}
